import { initCarousel } from "../../carousel";
import { initHeroVideo } from "./heroVideo";

document.addEventListener("DOMContentLoaded", () => {
  initCarousel("carousel-testimonials");
  initHeroVideo();
});
